module.exports = __webpack_public_path__ + "img/8.3784a0d9.jpg";